import http from '../http'
const API_URL = "department"

class departmentAPI {

  async getAllDepartment() {
    const response = await http(`${API_URL}`)
    return response
  } 
 
  
}

export default new departmentAPI()